/**
 * Owner: Masa Bayu
 * File: highlight-calculator.ts
 * Date:Time: 2026-10-05 15:22
 * Description: Fasa 26 GREEN · segmented highlight boxes per atom (pure math).
 */
/** X offset from atom left edge to the start of wordIndex. */
function getWordX(atom, wordIndex) {
    if (!atom.wordWidths)
        return 0;
    let x = 0;
    for (let j = 0; j < wordIndex * 2; j++) {
        x += atom.wordWidths[j] ?? 0;
    }
    return x;
}
/** Pixel width of the word at wordIndex. */
function getWordW(atom, wordIndex) {
    return atom.wordWidths ? (atom.wordWidths[wordIndex * 2] ?? 0) : 0;
}
/**
 * Compute per-line highlight rectangles for a selection.
 * One box per involved atom · never a single cross-line mega-rect.
 */
export function calculateHighlightBoxes(range, atoms) {
    if (!range || atoms.length === 0)
        return [];
    const startIndex = atoms.findIndex((a) => a.id === range.start.atomId);
    const endIndex = atoms.findIndex((a) => a.id === range.end.atomId);
    if (startIndex === -1 || endIndex === -1)
        return [];
    const isReversed = startIndex > endIndex;
    const actualStartIdx = isReversed ? endIndex : startIndex;
    const actualEndIdx = isReversed ? startIndex : endIndex;
    const actualStartPoint = isReversed ? range.end : range.start;
    const actualEndPoint = isReversed ? range.start : range.end;
    const boxes = [];
    for (let i = actualStartIdx; i <= actualEndIdx; i++) {
        const atom = atoms[i];
        if (!atom)
            continue;
        const isFirst = i === actualStartIdx;
        const isLast = i === actualEndIdx;
        let x = atom.bbox.x;
        let width = atom.bbox.width;
        if (isFirst) {
            const offsetX = getWordX(atom, actualStartPoint.wordIndex);
            x = atom.bbox.x + offsetX;
            width = atom.bbox.width - offsetX;
        }
        if (isLast) {
            const offsetX = getWordX(atom, actualEndPoint.wordIndex);
            const wordW = getWordW(atom, actualEndPoint.wordIndex);
            if (isFirst && isLast) {
                const endX = atom.bbox.x + offsetX + wordW;
                width = endX - x;
            }
            else {
                x = atom.bbox.x + offsetX;
                width = wordW;
            }
        }
        boxes.push({
            atomId: atom.id,
            x,
            y: atom.bbox.y,
            width,
            height: atom.bbox.height,
        });
    }
    return boxes;
}
//# sourceMappingURL=highlight-calculator.js.map